import { CodeEditorServiceImpl } from './services/CodeEditorService/impl';
import { TypedContainerModule } from '@thinkalpha/common/ioc/TypedContainer.js';
import type { ReactBindings } from 'src/types/bindings';

export const CodeEditorFeatureModule = new TypedContainerModule<ReactBindings>((bind) => {
    bind('CodeEditorService').to(CodeEditorServiceImpl);
});
